/**
 * Services Index
 * 
 * Central export point for all MobyNet services, including the new
 * browser extension integration services for massive file transfers.
 */

// Extension Integration Services
export { 
  ExtensionCapabilityService, 
  extensionCapabilityService,
  type PeerCapabilities,
  type ExtensionDetectionResult,
  TRANSFER_THRESHOLDS
} from './extension-capability-service';

// ❌ REMOVED: hybrid-file-transfer.ts - obsolete after direct integration migration

export {
  ExtensionBridge,
  extensionBridge,
  type ExtensionOperation,
  type ExtensionResponse,
  type ProgressUpdate,
  type CheckpointUpdate,
  type AssemblyProgress,
  type ProgressCallback,
  type CheckpointCallback,
  type AssemblyCallback
} from './extension-bridge';

export {
  CheckpointService,
  checkpointService,
  type FileTransferCheckpoint,
  type CheckpointStorageInfo,
  type ResumeResult
} from './checkpoint-service';

// ❌ REMOVED: integration-manager.ts - obsolete after direct integration migration

// Surveillance Detection Service
export {
  SurveillanceDetectionService,
  getSurveillanceDetectionService,
  ThreatLevel,
  ThreatType,
  type SurveillanceAlert,
  type SurveillanceConfig,
  type DTLSFingerprintRecord,
  type PeerIdentityBinding,
  type CandidatePairSnapshot,
  type ThroughputSample,
  type NetworkTimingStats,
  type MeshTopologyReport,
  type MeshInconsistency,
  type SDPIssue,
  type SurveillanceWorkerInbound,
  type SurveillanceWorkerOutbound,
} from './surveillance-detection-service';
